import { ConsiderRegisterComponent } from "../../components/RegisterSystem/ConsiderRegisterComponent";
import { Footer } from '../../components/share/Footer';
import { NavbarComponent } from "../../components/share/NavbarComponent";
import { HeadTitle } from "../../components/share/HeadTitle";

export function ConsiderRegisterContainer() {
    const titleName = "รายการคำขอลงทะเบียน";
    return (
        <div className="page-container bg-landing">

            <NavbarComponent />
            <HeadTitle title={titleName} />
            <ConsiderRegisterComponent />
            <Footer />
        </div>
    );
}